<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m39.43,73.5c-4.2,0-8.33-.88-12.02-2.55-11.97,4.9-19.05,1.25-19.35,1.09-.77-.41-1.21-1.25-1.12-2.12.09-.87.71-1.59,1.55-1.83,5.41-1.53,7.36-4.94,7.99-6.54-2.02-3.28-3.09-6.97-3.09-10.73,0-12.51,11.68-22.69,26.05-22.69,3.48,0,6.85.59,10.03,1.74,1.11.4,1.68,1.63,1.28,2.74-.4,1.11-1.63,1.68-2.74,1.28-2.71-.99-5.59-1.49-8.57-1.49-12,0-21.77,8.26-21.77,18.41,0,3.24,1.01,6.42,2.92,9.2.34.5.46,1.12.32,1.7-.22.93-1.3,4.58-5.14,7.52,2.71-.03,6.35-.63,10.84-2.6.58-.25,1.24-.24,1.81.05,3.32,1.66,7.13,2.53,11.02,2.53,12,0,21.76-8.26,21.76-18.4,0-1.18.96-2.14,2.14-2.14s2.14.96,2.14,2.14c0,12.51-11.68,22.68-26.04,22.68Z"/>
  <path class="cls-1" d="m83.07,39.13l-.47-6.85-5.8-.81-4.18-6.27,1-6.21-6.11-2.49-4.29,4.99h-6.96l-4.57-3.94-5.98,3.94,1.97,6.15-3.01,6.5-5.22,2.2v6.85l6.27,1.27,3.94,5.45-.93,6.15,6.73,2.78,3.25-4.41,7.54-.93,4.64,4.29,5.8-3.6-2.01-6.27,2.48-6.61,5.92-2.2Zm-21.81,9.72c-6.17,0-11.18-5-11.18-11.17s5.01-11.17,11.18-11.17,11.17,5,11.17,11.17-5.01,11.17-11.17,11.17Z"/>
  <path class="cls-3" d="m43.39,50.24l-3.66,3.57c-.25.24-.36.59-.31.93l.87,5.05c.15.86-.76,1.51-1.53,1.1l-4.54-2.38c-.3-.16-.67-.16-.98,0l-4.53,2.38c-.77.41-1.67-.25-1.53-1.1l.86-5.05c.06-.35-.05-.69-.3-.93l-3.66-3.57c-.62-.61-.28-1.67.59-1.8l5.06-.73c.35-.05.64-.27.79-.58l2.27-4.59c.39-.78,1.5-.78,1.88,0l2.27,4.59c.15.31.45.52.79.58l5.06.73c.86.12,1.21,1.19.59,1.8Z"/>
</svg>
</template>

<script>
export default {
    name: "CustomerPerformanceByBrandIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
  .cls-3 {
    fill: #bce2d2;
  }
</style>